import type { RendererProps } from "../core/element-registry"
import { useRenderContext } from "../core/render-context"
import { ElementRenderer } from "./element-renderer"
import { Popover, PopoverTrigger, PopoverContent } from "../components/ui/popover"
import { cn } from "../lib/utils"

export function PopoverRenderer({ element }: RendererProps) {
  const { dispatchEvent } = useRenderContext()

  const trigger = element.children?.[0]
  const content = element.children?.slice(1)

  const handleOpenChange = (open: boolean) => {
    dispatchEvent(element.id, open ? "open" : "close", {})
  }

  return (
    <Popover onOpenChange={handleOpenChange}>
      <PopoverTrigger asChild>
        <div className={cn("cursor-pointer", element.className)} data-testid={`popover-${element.id}`}>
          {trigger && <ElementRenderer element={trigger} />}
        </div>
      </PopoverTrigger>
      {content && content.length > 0 && (
        <PopoverContent>
          {content.map((child) => (
            <ElementRenderer key={child.id} element={child} />
          ))}
        </PopoverContent>
      )}
    </Popover>
  )
}
